var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardV4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 7.47925C6.9375 11.0974 9.88188 14.0417 13.5 14.0417C17.1181 14.0417 20.0625 11.0974 20.0625 7.47925C20.0625 3.86112 17.1181 0.916748 13.5 0.916748C9.88188 0.916748 6.9375 3.86112 6.9375 7.47925ZM25.1667 28.6251H26.625V27.1667C26.625 21.539 22.0444 16.9584 16.4167 16.9584H10.5833C4.95417 16.9584 0.375 21.539 0.375 27.1667V28.6251H25.1667Z",
    fill: "#FFA726"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardV4);
export default __webpack_public_path__ + "static/media/CardV4.f17c1dbcd79740f8ecc8a85789933c8a.svg";
export { ForwardRef as ReactComponent };